import { Component } from "@angular/core";
import { MinAppVersionService } from "src/app/services/min-app-version.service";

@Component({
  selector: "app-force-update-modal",
  templateUrl: "./force-update-modal.component.html",
  styleUrls: ["./force-update-modal.component.scss"],
})
export class ForceUpdateModalComponent {
  constructor(private minAppVersionService: MinAppVersionService) {}

  async update() {
    await this.minAppVersionService.openStore();
  }
}
